import React, { useCallback } from 'react';
import { Box, TextField, Button, MenuItem, Chip, Stack } from '@mui/material';
import CommonDatePicker from '../common/util/CommonDatePicker';

export const PurchaseMaintenanceSearchBox = ({ handleAdd, formik }) => {

    // 1. 날짜 변경 핸들러 최적화
    const onChangeDate = useCallback((newValue, name) => {
        formik.setFieldValue(name, newValue);
    }, [formik.setFieldValue]);

    // 2. 상태 칩 변경 핸들러 최적화
    const handleStatusChange = useCallback((status) => {
        formik.setFieldValue('searchStatus', status);
        // 상태 변경 즉시 조회를 위해 큐에 등록 (비동기 처리)
        setTimeout(() => formik.handleSubmit(), 0);
    }, [formik.setFieldValue, formik.handleSubmit]);

    // 상태 옵션 정의 (DB 코드값: N, Y, S 매핑)
    const statusOptions = [
        { label: '전체', value: '', color: '#757575' },
        { label: '수취 예정', value: 'N', color: '#ed6c02' },
        { label: '수취 완료', value: 'Y', color: '#2e7d32' },
    ];

    return (
        <Box sx={{ my: 2, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            {/* 1라인: 상세 검색 조건 및 실행 버튼 (우측 정렬) */}
            <Box
                component="form"
                noValidate
                autoComplete="off"
                onSubmit={formik.handleSubmit}
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    gap: 1,
                }}
            >
                <TextField
                    variant="standard"
                    select
                    name="searchKeyword"
                    label="검색키워드"
                    value={formik.values.searchKeyword}
                    onChange={formik.handleChange}
                    sx={{ width: '120px' }}
                >
                    <MenuItem value="cstNm">사업명</MenuItem>
                    <MenuItem value="partnerNm">매입처</MenuItem>
                    <MenuItem value="content">매입내용</MenuItem>
                    <MenuItem value="usrNm">영업담당자</MenuItem>
                    <MenuItem value="dptNm">부서명</MenuItem>
                </TextField>

                <TextField
                    variant="standard"
                    name="searchWords"
                    label="검색어"
                    value={formik.values.searchWords || ''}
                    onChange={formik.handleChange}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            formik.handleSubmit();
                        }
                    }}
                    sx={{ width: '180px' }}
                />

                <CommonDatePicker
                    label="시작일"
                    name="searchStrtDt"
                    value={formik.values.searchStrtDt}
                    formik={formik}
                    onChange={onChangeDate}
                />
                <CommonDatePicker
                    label="종료일"
                    name="searchEndDt"
                    value={formik.values.searchEndDt}
                    formik={formik}
                    onChange={onChangeDate}
                />

                <Button
                    type="submit"
                    color="info"
                    variant="contained"
                    disabled={formik.isSubmitting}
                    sx={{ ml: 1, minWidth: '80px' }}
                >
                    검색
                </Button>
                
                <Button 
                    color="primary" 
                    variant="contained" 
                    onClick={handleAdd}
                    sx={{ minWidth: '100px' }}
                >
                    일괄 발행
                </Button>
            </Box>

            {/* 2라인: 상태 필터 칩 (우측 정렬) */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Stack direction="row" spacing={1.5}>
                    {statusOptions.map((option) => {
                        const isSelected = formik.values.searchStatus === option.value;
                        return (
                            <Chip
                                key={option.value || 'all'}
                                label={option.label}
                                clickable
                                onClick={() => handleStatusChange(option.value)}
                                variant="outlined"
                                sx={{ 
                                    fontSize: '0.85rem', 
                                    px: 0.5,
                                    color: option.color,
                                    borderColor: option.color,
                                    borderWidth: isSelected ? '2px' : '1px',
                                    fontWeight: isSelected ? 'bold' : 'normal',
                                    backgroundColor: isSelected ? `${option.color}10` : 'transparent',
                                    transition: 'all 0.2s ease',
                                    '&:hover': {
                                        borderWidth: isSelected ? '2px' : '1px',
                                        backgroundColor: `${option.color}20`,
                                        borderColor: option.color,
                                    },
                                    '&.MuiChip-clickable:active': {
                                        boxShadow: 'none',
                                    }
                                }}
                            />
                        );
                    })}
                </Stack>
            </Box>
        </Box>
    );
};
